module.exports = __webpack_public_path__ + "img/module6.71c5177e.png";